var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-outline-secondary btn-sm download-button",attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.downloadCsv}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }